import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, Typography, IconButton, useTheme, Tooltip, Modal, Fade, Backdrop } from '@mui/material';
import { Add as AddIcon, Folder as FolderIcon, Share as ShareIcon, Link as LinkIcon } from '@mui/icons-material';
import { useQuery, useQueryClient } from 'react-query';
import { deleteFolder, getFolderI } from '../../api/services';
import CreateFolderDrawer from './CreateFolderDrawer';
import { useNavigate } from 'react-router-dom';
import QRCode from 'qrcode'; // Import qrcode package
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';


// <Admin folders={Tabsdata} />

const Admin: React.FC<{ foldersdata: any }> = ({ foldersdata }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const queryClient = useQueryClient();



  const [folders, setFolders] = useState<
    { id: string; name: string; count: number }[]
  >([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
    const [folderUrl, setFolderUrl] = useState<string>('');
   const [foldername, setFolderName] = useState<string>('');
   const [folderid, setFolderId] = useState<string>('');
    const [modalOpen, setModalOpen] = useState(false);
    const [qrmodalOpen, setQrModalOpen] = useState(false);
    const [qrImage, setQrImage] = useState<string>('');

    const Tabsdata = foldersdata; 

  useEffect(() => {
    if (Tabsdata) {
      const fetchedFolders = Tabsdata?.map((folder: any) => ({
        id: folder._id,
        name: folder.name,
        count: folder.files.length,
      }));
      setFolders(fetchedFolders);
      setFolderUrl(`https://portfolio.dezignshark.com/folders`);
    }
  }, [Tabsdata]);

  const handleCreateFolder = () => {
    setDrawerOpen(true);
  };



  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleDeleteFolder = (folderId: string) => {
    deleteFolder(folderId).then(() => {
      // Refetch the folders
      queryClient.invalidateQueries('alltabs');
      toast.success('Folder deleted successfully!');
    });
    
  };

  const handleDownloadQR = () => {
    if (qrImage) {
      const a = document.createElement('a');
      a.href = qrImage;
      a.download = 'FolderQRCode.png';
      a.click();
    }
  }

  const handleQrClose = () => {
    setQrModalOpen(false);
  }


      const handleShare = async () => {
        if (folderUrl) {
          try {
            QRCode.toDataURL(folderUrl, { width: 200, height: 200 }, (err, url) => {
              if (err) {
                console.error('Error generating QR code:', err);
                return;
              }
              setQrImage(url);
              // setModalOpen(true);
            });
            // setModalOpen(true);
          } catch (err) {
            console.error('Error generating QR code:', err);
          }
        }
      };
  

  return (
    <Box sx={{ p: 2  }}>
      {/* Header Section */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} sx={{ mx:1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="h4" color="primary" sx={{ fontWeight: '600' , }}>
          All Files 
        </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Tooltip title="Share All Folders">
           <IconButton 
            aria-label="Share" 
            size="small"
            onClick={ () => {setQrModalOpen(true); handleShare();} }
            sx={{ mr: 1, p: 1 }}
          >
            <ShareIcon fontSize="small" />
          </IconButton>
          </Tooltip>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleCreateFolder}
        >
          Create Folder
        </Button>
        </Box>
      </Box>

      {/* Folder Grid */}
      <Grid container spacing={3}>
        {folders.map((folder) => (
          <Grid item xs={12} sm={6} md={3} key={folder.id}>
            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                p: 3,
                border: `2px solid ${theme.palette.divider}`,
                borderRadius: 4,
                boxShadow: theme.palette.mode === 'dark' ? 4 : 2,
                backgroundColor: theme.palette.background.paper,
                width: '100%',
                height: 200,
                ':hover': {
                  boxShadow: 6,
                  backgroundColor: theme.palette.action.hover,
                },
                overflow: 'hidden',
                '&:hover .hover-icons': {
                  opacity: 1,
                },
              }}

              // on double click then navigate to the folder/:id page
              onDoubleClick={() => { navigate(`/folder/${folder.id}`) }}
            >
              {/* Hover Icons */}
              <Box
                className="hover-icons"
                sx={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 1,
                  opacity: 0,
                  transition: 'opacity 0.3s',
                }}
              >
                <IconButton aria-label="Share" size="small">
                  <ShareIcon fontSize="small" />
                </IconButton>
                <IconButton aria-label="Copy Link" size="small">
                  <LinkIcon fontSize="small" />
                </IconButton>
                {/* <IconButton aria-label="Delete" size="small" sx={{ color: 'error.main' }} onClick={() => { setModalOpen(true); setFolderName(folder.name); setFolderId(folder.id); } }>
                  <FontAwesomeIcon icon={faTrash} />
                </IconButton> */}
              </Box>
              <FolderIcon
                sx={{ fontSize: 80, color: theme.palette.grey[600], mb: 2 }}
              />
            </Box>

            {/* Folder Name and Count */}
            <Box
              sx={{
                m: 1,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FolderIcon fontSize="large" />
              </Box>
              <Box sx={{ ml: 1, textAlign: 'flex-start' }}>
                <Typography variant="body1" noWrap sx={{ fontWeight: '600' }}>
                  {folder.name}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  noWrap
                  sx={{ fontWeight: '400', opacity: 0.7 }}
                >
                  Total Items: {folder.count}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Create Folder Drawer */}
      <CreateFolderDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />

        {/* create a modal where i want like in the center like are you sure you want to delete this folder */}
        <Modal
      open={modalOpen}
      onClose={handleCloseModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: { bgcolor: 'rgba(0, 0, 0, 0.6)' }, // Semi-transparent backdrop for a modern feel
      }}
    >
      <Fade in={modalOpen}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '400px' },
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: '500', marginBottom: 2 }}>
            Are you sure you want to delete this : <b>{foldername}</b> 
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', marginBottom: 3 }}>
            This action cannot be undone. Make sure you really want to delete this folder.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
            <Button
              variant="outlined"
              color="error"
              sx={{
                textTransform: 'none',
                fontWeight: 'bold',
                borderRadius: 2,
                paddingX: 3,
              }}
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{
                textTransform: 'none',
                fontWeight: 'bold',
                borderRadius: 2,
                paddingX: 3,
              }}
              onClick={() => {
                handleDeleteFolder(folderid);
                handleCloseModal();
              }}
              >
              Confirm
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>


    <Modal open={qrmodalOpen} onClose={setQrModalOpen}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '90%', sm: '80%', md: 400 },
                bgcolor: 'background.paper',
                boxShadow: 24,
                borderRadius: 2,
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {/* Modal Header */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  px: 2,
                  py: 1,
                  bgcolor: 'primary.main',
                  color: 'white',
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: '500' }}>
                  QR Code
                </Typography>
                <IconButton onClick={handleQrClose} sx={{ color: 'white' }}>
                  <CloseIcon />
                </IconButton>
              </Box>
    
              {/* Modal Content */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  px: 3,
                  py: 4,
                }}
              >
                {qrImage ? (
                  <img
                    src={qrImage}
                    alt="QR Code"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '200px',
                      marginBottom: '16px',
                      userSelect: 'none',
                    }}
                  />
                ) : (
                  <Typography variant="body1" color="textSecondary">
                    Generating QR code...
                  </Typography>
                )}
    
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    gap: 2,
                    width: '100%',
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={ () => { handleDownloadQR(); setQrModalOpen(false); } }
                    sx={{
                      flexGrow: 1,
                      maxWidth: { xs: '100%', sm: '48%' },
                    }}
                  >
                    Download QR
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleQrClose}
                    sx={{
                      flexGrow: 1,
                      maxWidth: { xs: '100%', sm: '48%' },
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>






      


    </Box>
  );
};

export default Admin;
